import { useState } from "react";
import { useResetPassword } from "../hooks/userResetPassword";
import { Eye, EyeOff } from "lucide-react";

export default function ResetPasswordForm({ token }) {
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [matchError, setMatchError] = useState("");

  // ✅ toggle states for each field
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const { resetPassword, isLoading, message, error } = useResetPassword();

  const handleSubmit = (e) => {
    e.preventDefault();
    setMatchError("");
    if (password !== confirmPassword) {
      setMatchError("Passwords do not match");
      return;
    }
    resetPassword(token, password, confirmPassword); // ✅ all 4
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      {/* OLD PASSWORD */}
      {token ? null : (
        <div className="relative">
          <input
            type={showOld ? "text" : "password"}
            placeholder="Old Password"
            required
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            className="w-full p-3 pr-11 rounded-xl border border-slate-300 dark:border-slate-600 dark:bg-slate-700"
          />
          <button
            type="button"
            onClick={() => setShowOld(!showOld)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
          >
            {showOld ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        </div>
      )}

      {/* NEW PASSWORD */}
      <div className="relative">
        <input
          type={showNew ? "text" : "password"}
          placeholder="New Password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full p-3 pr-11 rounded-xl border border-slate-300 dark:border-slate-600 dark:bg-slate-700"
        />
        <button
          type="button"
          onClick={() => setShowNew(!showNew)}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
        >
          {showNew ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
      </div>

      {/* CONFIRM PASSWORD */}
      <div className="relative">
        <input
          type={showConfirm ? "text" : "password"}
          placeholder="Confirm Password"
          required
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className="w-full p-3 pr-11 rounded-xl border border-slate-300 dark:border-slate-600 dark:bg-slate-700"
        />
        <button
          type="button"
          onClick={() => setShowConfirm(!showConfirm)}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
        >
          {showConfirm ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
      </div>

      {matchError && <p className="text-red-500 text-sm">{matchError}</p>}
      {error && <p className="text-red-500 text-sm">{error}</p>}
      {message && <p className="text-green-500 text-sm">{message}</p>}

      {/* ✅ button text changed to Change Password */}
      <button
        type="submit"
        disabled={isLoading}
        className="w-full bg-[#1d57a5] text-white py-3 rounded-xl font-semibold hover:opacity-90 transition"
      >
        {token ? (
            isLoading ? "Resetting..." : "Reset Password"
          ) : (
            isLoading ? "Changing..." : "Change Password"
          )}
      </button>
    </form>
  );
}
